import { withInstall } from '@haohan/clw-utils'
import PreviewLayout from './index.vue'
export const HHPreviewView = withInstall(PreviewLayout)
export default HHPreviewView
